import { render, staticRenderFns } from "./DialogEditor.vue?vue&type=template&id=f43d2c72&"
import script from "./DialogEditor.vue?vue&type=script&lang=js&"
export * from "./DialogEditor.vue?vue&type=script&lang=js&"
import style0 from "./DialogEditor.vue?vue&type=style&index=0&id=f43d2c72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports